import {GridSeeker, IconSeekers, ModalSeeker} from "ui-seeker/core"
import EventCreationForm from "./Form"
import DateSelection from "./DateSelection"
import { useAppCalendarEventCreation } from "./@hooks"
import React from "react"

export default function AppCalendarEventCreationModal() {

    const { updateForm, isOpen, handleSubmit, updateCalendarEvents } = useAppCalendarEventCreation()


    const modalConfig = {
        isOpen,
        controller: () => updateCalendarEvents({ isOpenFormModal: false }),
        title: <TitleModal />,
        size: 'xs',
        okClassName: 'bg-primary-top',
        onSuccess: handleSubmit,
        onCancel: () => updateCalendarEvents({ isOpenFormModal: false }),
        backdropClassName: 'daily-price-event'
    }

    return <ModalSeeker {...modalConfig}>
        <GridSeeker container>
            <EventCreationForm updateForm={updateForm} />
            <DateSelection updateForm={updateForm} />
        </GridSeeker>
    </ModalSeeker>
}

function TitleModal() {
    return <span>
		<IconSeekers icon="calendar-check" iconType="fontAwesome" /> Add event
	</span>
}
